import * as R from 'ramda'
import React from 'react'
import { connect } from 'react-redux'
import { firestoreConnect, isLoaded, withFirestore } from 'react-redux-firebase'
import { withRouter } from 'react-router'
import { compose, withProps } from 'recompose'
import { sortCategoriesByDefaultOrder } from 'src/helpers/compare'
import { Championship, ChampionshipId } from 'src/schemas/Championship'
import { ChampionshipCategory } from 'src/schemas/ChampionshipCategory'
import { ChampionshipResults } from 'src/schemas/ChampionshipResults'
import { Tournament } from 'src/schemas/Tournament'

import { findInOrdered, fsCollections } from '../../helpers/firestore'

import { TenantId } from '../../schemas/Tenant'

import './ChampionshipResultList.css'
import ChampionshipResultsInCategory from './ChampionshipResultsInCategory'

type ResultListOuterProps = {
  tenant: TenantId
  championshipId: ChampionshipId
}

type ResultListInnerProps = ResultListOuterProps & {
  dataIsLoaded: boolean
  categories?: ChampionshipCategory[]
  championship?: Championship
  tournaments?: Tournament[]
  results?: ChampionshipResults[]
}

class ResultList extends React.Component<ResultListInnerProps> {
  render() {
    const {
      dataIsLoaded,
      tenant,
      championship,
      categories = [],
      tournaments = [],
      results = [],
    } = this.props

    const sortedCategories = sortCategoriesByDefaultOrder(categories)

    return (
      <div className="ResultList">
        {sortedCategories.map((category) => {
          return (
            <React.Fragment key={category.id}>
              <ChampionshipResultsInCategory
                dataIsLoaded={dataIsLoaded}
                tenant={tenant}
                championship={championship}
                tournaments={tournaments}
                category={category}
                results={results.filter((result) => category.id in result.points)}
              />
            </React.Fragment>
          )
        })}
      </div>
    )
  }
}

export default compose<ResultListInnerProps, ResultListOuterProps>(
  withRouter,
  withFirestore,
  firestoreConnect<FIXME>(({ tenant, championshipId }) => [
    { collection: fsCollections.championships(tenant), doc: championshipId },
    { collection: fsCollections.championshipCategories(tenant, championshipId) },
    { collection: fsCollections.championshipResults(tenant, championshipId) },
    {
      collection: fsCollections.tournaments(tenant),
      where: [
        ['championshipId', '==', championshipId],
        ['public', '==', true],
      ],
      orderBy: ['dateFrom', 'asc'],
    },
  ]),
  connect(({ firestore }: FIXME, { tenant, championshipId }: FIXME) => ({
    championship: findInOrdered(
      firestore.ordered[fsCollections.championships(tenant)],
      championshipId,
    ),
    categories: firestore.ordered[fsCollections.championshipCategories(tenant, championshipId)],
    tournaments: R.sortBy<Tournament>(
      (tournament) => tournament?.dateFrom,
      firestore.ordered[fsCollections.tournaments(tenant)]?.filter(
        (tournament) => tournament.championshipId === championshipId,
      ) || [],
    ),
    results: firestore.ordered[fsCollections.championshipResults(tenant, championshipId)],
  })),
  withProps(({ championship, categories, tournaments, results }) => ({
    dataIsLoaded: isLoaded(championship, categories, tournaments, results),
  })),
)(ResultList)



// WEBPACK FOOTER //
// ./src/components/championship/ChampionshipResultList.tsx